<template>
  <div>
    <em
      class="qx-icon icon-download"
      @click="isDecryptedFile ? saveDecryptedFile() : decryptModalState(true)" />
    <decrypt-download
      v-if="showDecryptModal"
      ref="decryptDownload"
      :is-visible="showDecryptModal"
      :shared-item="sharedItem"
      :download-url="downloadUrl"
      @close="setDecryptedFile" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { saveAs } from 'file-saver';

import DecryptDownload from '@/elements/files/decryptDownload.vue';

import { fetchDownloadLink } from '@/api';

export default {
  name: 'DecryptButton',
  components: {
    DecryptDownload,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      downloadUrl: '/share/download/',
      showDecryptModal: false,
      decryptedFile: null,
      fileName: '',
    };
  },
  computed: {
    ...mapState({
      metadata: (state) => state.downloadPage.metadata,
    }),
    sharedItem() {
      return {
        privateKey: this.metadata.privateKey,
        item: this.item,
        fetchLink: fetchDownloadLink,
      };
    },
    isDecryptedFile() {
      return Boolean(this.decryptedFile);
    },
  },
  methods: {
    setDecryptedFile({ file, fileName }) {
      this.decryptedFile = file;
      this.fileName = fileName;
      this.decryptModalState(false);
    },
    decryptModalState(state) {
      this.showDecryptModal = state;
    },
    saveDecryptedFile() {
      saveAs(this.decryptedFile, this.fileName);
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-download {
  color: $base-blue;
  cursor: pointer;
}
</style>
